import { useMemo, useState } from "react";
import { Outlet } from "react-router-dom";

import { useARC } from "providers/ARC/ARCProvider";

import ARCErrorPanel from "components/error/ARCErrorPanel";
import NavigateToPoseBanner from "components/navigation/NavigateToPoseBanner";
import TopBar from "components/layout/navbar/TopBar";
import AnimatedModal from "components/layout/motion/AnimatedModal";
import SelectARC from "components/ARC/SelectARC";

import { ConnectionState } from "lib/consts/ARC/connection";

const MapLayout = () => {
    const { selectARC, selectedARC, connectionState } = useARC();

    const [showSelectARC, setShowSelectARC] = useState(false);

    const serialNumber = useMemo(() => selectedARC?.serialNumber, [selectedARC]);

    return (
        <div className="layout flex min-h-0 min-w-0 flex-1 flex-col pl-20">
            <TopBar title={"Map"} />
            {serialNumber &&
            [ConnectionState.Connected, ConnectionState.Connecting].includes(connectionState) ? (
                <div className="relative flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
                    <NavigateToPoseBanner />
                    <Outlet />
                </div>
            ) : (
                <ARCErrorPanel
                    className="bg-black100"
                    title={
                        !serialNumber
                            ? "Please select an ARC to access"
                            : `Cannot connect to ${serialNumber}`
                    }
                    subTitle={
                        ![ConnectionState.Connected, ConnectionState.Connecting].includes(
                            connectionState
                        ) && "Select another ARC to access"
                    }
                    onClick={() => setShowSelectARC(true)}
                />
            )}
            <AnimatedModal
                visible={showSelectARC}
                onClose={() => setShowSelectARC(false)}
                className="w-150 max-w-full !overflow-visible"
            >
                <SelectARC
                    cardOnClickTitle="Access"
                    cardOnClick={(info) => selectARC(info.serialNumber)}
                    onClose={() => setShowSelectARC(false)}
                />
            </AnimatedModal>
        </div>
    );
};

export default MapLayout;
